<template>
  <el-input type="textarea" :rows="8" v-model="inner" :placeholder="placeholder"></el-input>
</template>

<script>
// demo 中富文本以多行文本框简化呈现（详情页以 v-html 渲染）
export default {
  name: 'RichEditor',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '请输入内容（支持 HTML）' }
  },
  computed: {
    inner: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  }
}
</script>
